// De chips onder de filterbalk: wat staat er nú aan, en haal het er met één
// klik weer af. Vorm uit het goedgekeurde V2-scherm (screenshot owner
// 2026-08-24): lichtgrijze pil, radius 99, label plus een kruisje.

import { color, radius, size, weight } from "../tokens";

export type Chip = { axis: string; value: string; label: string };

export function FilterChips({
  chips,
  onRemove,
  onClearAll,
}: {
  chips: Chip[];
  onRemove: (chip: Chip) => void;
  onClearAll: () => void;
}) {
  if (chips.length === 0) return null;
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 8,
        alignItems: "center",
        marginTop: 12,
        paddingTop: 12,
        borderTop: `1px solid ${color.lineFaint}`,
      }}
    >
      {chips.map((chip) => (
        <span
          key={`${chip.axis}:${chip.value}`}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 7,
            background: color.lineFaint,
            border: `1px solid ${color.border}`,
            color: color.body,
            borderRadius: radius.pill,
            padding: "5px 10px",
            fontSize: size.meta,
            fontWeight: weight.regular,
            maxWidth: 320,
          }}
        >
          <span
            style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
            title={`${chip.axis}: ${chip.label}`}
          >
            {chip.label}
          </span>
          <button
            onClick={() => onRemove(chip)}
            aria-label={`${chip.label} verwijderen`}
            style={{
              background: "none",
              border: "none",
              color: color.faint,
              cursor: "pointer",
              padding: 0,
              lineHeight: 1,
              fontSize: 14,
              fontFamily: "inherit",
            }}
          >
            ×
          </button>
        </span>
      ))}
      <button
        onClick={onClearAll}
        style={{
          background: "none",
          border: "none",
          color: color.faint,
          fontSize: size.meta,
          fontFamily: "inherit",
          cursor: "pointer",
        }}
      >
        alles wissen
      </button>
    </div>
  );
}
